import { component } from 'picoapp'

export default component(node => {
    const login = node.querySelector('[data-login-dialog]')
    const recover = node.querySelector('[data-recover-dialog]')
    const recoverLink = node.querySelector('[data-recover-trigger]')
    const cancelRecoverLink = node.querySelector('[data-recover-cancel]')

    const recoverIsTarget = window.location.hash.match(/\#recover/) ? true : false

    const successMessage = node.querySelector('[data-recover-success]') !== null

    if (recoverIsTarget || successMessage) {
        login.style.display = 'none'
        recover.style.display = 'block'
    } else {
        login.style.display = 'block'
    }

    recoverLink.addEventListener('click', (e) => {
        e.preventDefault()
        login.style.display = 'none'
        recover.style.display = 'block'
    })

    cancelRecoverLink.addEventListener('click', (e) => {
        e.preventDefault()
        recover.style.display = 'none'
        login.style.display = 'block'
        // clear "#recover" from url to prevent reload confusion
        history.pushState("", document.title, window.location.pathname + window.location.search);
        // remove all errors
        recover.querySelectorAll('[data-form-error]').forEach(elem => {
          elem.remove()
        })
    })
})